import { get } from 'lodash';
import styled from 'styled-components';

const IconCheck = ({ fill = '#E5E6EB' }: { fill?: string }) => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M13.0161 22.5C12.6159 22.5 12.2357 22.3326 11.9555 22.0396L6.29264 16.117C5.71235 15.5101 5.71235 14.5056 6.29264 13.8987C6.87292 13.2918 7.8334 13.2918 8.41369 13.8987L13.0161 18.7121L23.3012 7.95518C23.8814 7.34827 24.8419 7.34827 25.4222 7.95518C26.0025 8.56209 26.0025 9.56662 25.4222 10.1735L14.0766 22.0396C13.7965 22.3326 13.4163 22.5 13.0161 22.5Z" fill={fill} />
  </svg>
);
const configs = {
  request: {
    label: 'Request Staff',
    shortLabel: 'Request',
    fill: '#D2464F',
  },
  'none-request': {
    label: 'None-request',
    shortLabel: 'None-req',
    fill: '#B67650',
  },
  online: {
    label: 'Online',
    shortLabel: 'Online',
    fill: '#FF7D00',
  },
};
type Props = {
  value?: boolean;
  onClick?: () => void;
  type?: 'request' | 'none-request' | 'online';
  small?: boolean;
  icon?: boolean;
};
const CheckBoxUI = ({ icon, value, onClick, type = 'request', small }: Props) => {
  const config = get(configs, [type]);
  if (!config) return null;
  if (icon) return (
    <Container htmlFor='request-staff' onClick={(e: React.MouseEvent<HTMLLabelElement, MouseEvent>) => {
      e.stopPropagation();
      onClick?.();
    }}>
      <div className="request-staff-container" style={{ background: config.fill }}>
        <div className="request-staff-container-icon">
          <IconCheck fill={!value ? '#fff' : config.fill} />
        </div>
      </div>
    </Container>
  );
  return (
    <Container htmlFor='request-staff' onClick={(e: React.MouseEvent<HTMLLabelElement, MouseEvent>) => {
      e.stopPropagation();
      onClick?.();
    }}>
      <div className="request-staff-container" style={{ background: config.fill }}>
        <div className="request-staff-container-icon">
          <IconCheck fill={!value ? '#fff' : config.fill} />
        </div>
        <div className="request-staff-container-item">
          <span className="label">{small ? config.shortLabel : config.label}</span>
        </div>
      </div>
    </Container>
  );
};
export default CheckBoxUI;
const Container = styled.label`
  display: flex;
  align-items: center;
  .request-staff-container {
    display: flex;
    padding: 8px;
    align-items: center;
    gap: 8px;
    border-radius: 8px;
    background: #D2464F;
    &:hover {
      cursor: pointer;
      opacity: 0.8;
    }
    .request-staff-container-icon {
      width: 40px;
      height: 40px;
      aspect-ratio: 1/1;
      border-radius: 100px;
      background: #fff;
      display: flex;
      align-items: center;
      justify-content: center;
    }
    .request-staff-container-item {
      span {
        color: #fff;
        font-family: Poppins;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: normal;
      }
    }
  }
`;